'use strict';

/* globals RELATIVE_PATH, socket */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('fill-blanks-game-start', {
		props: ['initData'],
		methods: {
			start: function () {
				this.initData.isStarted = true;
				internals.logStartedGame(this.initData.uuid, this.initData.game.gameId);
			},
		},
		template:
		'<div class="text-center">' +
			'<h1>{{initData.translations.fillBlanksGame}}</h1>' +
			'<p>{{initData.translations.fillBlanksGameDescription}}</p>' +
			'<button type="button" class="btn btn-primary" v-on:click="start()">{{initData.translations.startAnswering}}</button>' +
		'</div>',
	});

	internals.logStartedGame = function (uuid, gameId) {
		socket.emit('plugins.fillBlanksGameAnalytics.startedGame', { gameId: gameId, uuid: uuid });
	};
});
